/**
 * Public place label: city, state/region (when it adds information), country.
 */

function trimField(value) {
  return value ? String(value).trim() : '';
}

/** State or region to show — skip empty or duplicate city-state names. */
export function locationRegion(loc) {
  if (!loc) return '';
  var city = trimField(loc.city);
  var region = trimField(loc.region);
  var regionCode = trimField(loc.regionCode);
  var country = trimField(loc.country);
  var countryCode = trimField(loc.countryCode);

  if (region && region !== city && region !== country) return region;
  if (
    regionCode &&
    regionCode !== city &&
    regionCode !== country &&
    regionCode !== countryCode
  ) {
    return regionCode;
  }
  return '';
}

export function formatLocationLabel(loc) {
  var city = loc ? trimField(loc.city) : '';
  var region = locationRegion(loc);
  var country = loc ? trimField(loc.country) : '';
  var parts = [];
  if (city) parts.push(city);
  if (region) parts.push(region);
  if (country && country !== city) parts.push(country);
  else if (!city && country) parts.push(country);
  return parts.join(', ');
}
